import gapRiskReducer from '../state/gap-risk-slice'

export const gapRiskReducers = {
  gapRisk: gapRiskReducer
}
